// import Cookies from 'js-cookie'
// 当前系统与IPM同域名在localStorage取值
const TokenKey = 'access_token'

export function getToken() {
  return localStorage.getItem(TokenKey)
}

export function setToken(token) {
  return localStorage.setItem(TokenKey, token)
}

export function removeToken() {
  return localStorage.removeItem(TokenKey)
}